import React from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationInbox from './NotificationInbox';
import './NotificationBottomSheet.css';

export interface NotificationBottomSheetProps {
  onClose: () => void;
}

export const NotificationBottomSheet: React.FC<NotificationBottomSheetProps> = ({ onClose }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="notif-sheet-backdrop" onClick={onClose} aria-hidden="true" />
      <div
        className="notif-sheet"
        role="dialog"
        aria-modal="true"
        aria-label="Уведомления"
      >
        <div className="sheet-grabber" />
        <NotificationInbox
          onClose={onClose}
          onNavigate={(url) => navigate(url)}
        />
      </div>
    </>
  );
};

export default NotificationBottomSheet;
